export const getRandomColor = () => {
  const blueColors = [
    // Light blues
    '#ADD8E6', // Light blue
    '#87CEEB', // Sky blue
    '#B0E0E6', // Powder blue
    '#00BFFF', // Deep sky blue
    '#1E90FF', // Dodger blue
    '#6495ED', // Cornflower blue
    '#4682B4', // Steel blue
    '#5F9EA0', // Cadet blue
    '#4169E1', // Royal blue
    '#7B68EE', // Medium slate blue
    // Medium blues
    '#0000FF', // Blue
    '#0000CD', // Medium blue
    '#4169E1', // Royal blue
    '#6A5ACD', // Slate blue
    '#7B68EE', // Medium slate blue
    '#6495ED', // Cornflower blue
    '#4682B4', // Steel blue
    // Dark blues
    '#00008B', // Dark blue
    '#191970', // Midnight blue
    '#000080', // Navy
    '#483D8B', // Dark slate blue
    '#2E4053', // Dark slate gray blue
    '#1A5276', // Deep blue
    '#154360', // Very dark blue
    '#0E2C40', // Navy dark
    '#0B3861', // Dark navy
  ]
  return blueColors[Math.floor(Math.random() * blueColors.length)]
}
